import React from 'react';
import {COMPONENT_TYPES, INTERACTIVE} from '../constants';
import {ComponentType} from '../types';

import {SecondaryButton} from 'components';
import ComponentListItem from './ComponentListItem';

import i18n from 'i18next';

interface ComponentListProps {
  onCancel: () => void;
  onSelectComponent: (type: ComponentType) => void;
  disabledInteractive?: boolean;
}

export default function ComponentList(props: ComponentListProps) {
  const componentListItems = Object.values(COMPONENT_TYPES).map((value, i) => {
    const isDisabled = !!(
      props.disabledInteractive &&
      value &&
      INTERACTIVE.includes(value)
    );

    return (
      <React.Fragment key={value}>
        {i === 0 ? null : <hr />}
        <ComponentListItem
          value={value}
          disabled={isDisabled}
          onClick={() => {
            if (!isDisabled) {
              props.onSelectComponent(value);
            }
          }}
        />
      </React.Fragment>
    );
  });

  return (
    <>
      {/* List of components */}
      <ul>{componentListItems}</ul>

      {/* Cancel button. Aligned to the right side. */}
      <div className="text-right">
        <SecondaryButton onClick={props.onCancel}>
          {i18n.t('common.cancel')}
        </SecondaryButton>
      </div>
    </>
  );
}
